import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppWidget from "./WhatsAppWidget";
import { Building2, Shield, Zap, ArrowRight, Globe, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

const GrandiAziendePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const solutions = [
    {
      title: "Connettività Enterprise",
      description: "Fibra ottica dedicata fino a 10 Gbps con SLA garantiti per le grandi organizzazioni che necessitano di massima affidabilità.",
      icon: <Building2 className="w-12 h-12 text-orange-500" />,
      features: ["Fibra Dedicata a Progetto", "SLA 99.99%", "Direct Cloud Access", "Assistenza H24 Dedicata"]
    },
    {
      title: "Cyber Security & SD-WAN",
      description: "Soluzioni di rete intelligenti e sicure per connettere sedi diverse e proteggere i dati aziendali con tecnologie avanzate.",
      icon: <Shield className="w-12 h-12 text-orange-500" />,
      features: ["Architettura SD-WAN", "Managed Firewall", "Endpoint Protection", "SOC as a Service"]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-7xl font-black text-gray-900 mb-8 tracking-tighter uppercase">
              Potenza <span className="text-orange-500 underline decoration-8">Senza Limiti</span>.
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 mb-12 font-medium leading-relaxed">
              Soluzioni su misura per Grandi Aziende e Corporate. Innovazione, sicurezza e performance scalabili per guidare la trasformazione digitale del tuo business.
            </p>
            <div className="flex justify-center">
              <Link to="/preventivo" className="bg-gray-900 text-white px-12 py-6 rounded-2xl font-black text-xl hover:bg-orange-500 transition-all">
                Contatta Account Manager
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <div className="bg-gray-900 py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { label: "Enterprise SLA", icon: <Shield /> },
              { label: "Dedicated PM", icon: <Building2 /> },
              { label: "Global Presence", icon: <Globe /> },
              { label: "High Performance", icon: <Zap /> }
            ].map((item, i) => (
              <div key={i} className="flex flex-col items-center text-center text-white">
                <div className="text-orange-500 mb-4">{item.icon}</div>
                <span className="font-bold text-sm uppercase tracking-widest">{item.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Solutions Grid */}
      <section className="py-32 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
            {solutions.map((solution, index) => (
              <div key={index} className="group">
                <div className="bg-white p-12 rounded-[4rem] border border-gray-100 group-hover:shadow-2xl transition-all duration-700 h-full">
                  <div className="mb-8">{solution.icon}</div>
                  <h3 className="text-4xl font-black text-gray-900 mb-6 tracking-tight uppercase">{solution.title}</h3>
                  <p className="text-xl text-gray-600 mb-10 leading-relaxed">{solution.description}</p>
                  <ul className="space-y-4 mb-12">
                    {solution.features.map((feature, i) => (
                      <li key={i} className="flex items-center space-x-3 text-gray-700 font-bold">
                        <CheckCircle2 className="w-5 h-5 text-green-500" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Link to="/preventivo" className="inline-flex items-center text-orange-500 font-black text-lg uppercase tracking-widest group-hover:translate-x-4 transition-transform">
                    Approfondisci <ArrowRight className="ml-2" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Corporate Banner */}
      <section className="container mx-auto px-4 pb-32">
        <div className="bg-orange-500 rounded-[3rem] p-12 md:p-24 relative overflow-hidden text-white text-center">
          <div className="relative z-10 max-w-3xl mx-auto">
            <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tighter leading-tight uppercase">
              Partner della Tua Crescita.
            </h2>
            <p className="text-2xl mb-12 font-bold opacity-90">
              Oltre la connettività: un team di esperti pronto a progettare l'infrastruttura tecnologica del tuo futuro.
            </p>
            <Link to="/preventivo" className="bg-white text-black px-12 py-6 rounded-2xl font-black text-xl hover:bg-gray-900 hover:text-white transition-all">
              Richiedi Analisi Custom
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppWidget />
    </div>
  );
};

export default GrandiAziendePage;
